function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiChat = function SvgAiChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.829,
    height: 25.004,
    viewBox: "0 0 6.834 6.616",
    role: "presentation"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M120.782 25.744v2.524a1.01 1.01 0 0 0 1.011 1.01h.505v.758l1.527-.757h1.516a1.01 1.01 0 0 0 1.01-1.01v-2.525a1.01 1.01 0 0 0-1.01-1.01h-3.548a1.01 1.01 0 0 0-1.01 1.01z",
    style: {
      strokeWidth: 0.464583,
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10
    },
    transform: "translate(-120.15 -24.117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.237 27.01c.568.153 1.178.763 1.33 1.33v-1.33zm1.33 1.33c.152-.567.762-1.177 1.33-1.33h-1.33zm1.33-1.33c-.568-.151-1.178-.761-1.33-1.329v1.33zm-1.33-1.329c-.152.568-.762 1.178-1.33 1.33h1.33z",
    style: {
      fill: "currentColor",
      strokeWidth: 0.0235274,
      strokeOpacity: 0.987406
    },
    transform: "translate(-120.15 -24.117)"
  }));
};
export default SvgAiChat;